<template>
  <div class="attach-product-wrapper" :id="divId" v-bind:style="`background-color: ${backgroundColor}`">
    <div class="block-heading-font-style">{{ title }}</div>
    <div class="block-subheading-font-style">{{ subtitle }}</div>
    <div class="product-item" v-for="product in products">
      <SingleProductComponent :product="product"></SingleProductComponent>
    </div>

    <a href="#contact-footer" v-on:click="logCtaClick" class="mobile-cta-button" v-bind:class="[shouldShowMainCta ? 'mobile-cta-button-visible' : 'mobile-cta-button-hidden']">
      {{ mobileCta }}
    </a>
  </div>
</template>

<script>

import SingleProductComponent from './SingleProductComponent'

import productScrollHelper from './productScrollHelper'

export default {
  props: [ 'products', 'title', 'subtitle', 'divId', 'backgroundColor', 'mobileCta', 'mobileCtaMessage' ],
  data() {
    return {
      shouldShowMainCta: undefined
    }
  },
  components: {
    SingleProductComponent: SingleProductComponent
  },
  mounted() {
    // if (!window.sr) window.sr = ScrollReveal()
    // window.sr.reveal('.attach-product-wrapper', { delay: 250, duration: 500 })
    this.scrollListener()
  },
  methods: {
    resetScroll() {
      setTimeout(() => {
        window.scrollBy(0, -48)
      }, 10)
    },
    scrollListener() {
      let self = this
      $(window).scroll(function(){
        let shouldShowMainCta = productScrollHelper.scrollListener(self.divId)
        self.updateShouldShowMainCta(shouldShowMainCta)
      });
    },
    updateShouldShowMainCta(shouldShow) {
      if (shouldShow && !this.shouldShowMainCta) this.shouldShowMainCta = true
      if (!shouldShow && this.shouldShowMainCta) this.shouldShowMainCta = false
    },
    logCtaClick() {
      if (!window.mmProductInterests) window.mmProductInterests = []
      window.mmProductInterests.push(this.mobileCtaMessage)
      this.resetScroll()
    }
  },
  computed: {},
  watch: {}
}
</script>

<style scoped>

  .attach-product-wrapper {
    display: block;
    padding: 24px;
  }

  @media only screen and (max-width: 650px) {
    .attach-product-wrapper {
      display: block;
      padding: 24px 12px;
    }
  }

  .mobile-cta-button {
    display: none;
  }

  .mobile-cta-button-hidden,
  .mobile-cta-button-visible {
    transition: ease-in-out 0.225s;
    background: #409dd4;
    background: #00a9bc;
    background: linear-gradient(135deg, #24af94 0%,#31c4a8 69%,#19d09d 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00a9bc', endColorstr='#00bfbd',GradientType=1 );
    position: fixed;
    left: 0;
    right: 0;
    text-align: center;
    padding: 16px;
    color: white;
    font-weight: lighter;
    z-index: 2;
    text-decoration: none;
  }

  @media only screen and (max-width: 650px) {
    .mobile-cta-button {
      display: block;
    }
    .mobile-cta-button-visible {
      bottom: 0;
    }
    .mobile-cta-button-hidden {
      bottom: -500px;
    }
  }

</style>



// WEBPACK FOOTER //
// StudiosProductComponent.vue?16585ee5